var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7524 30.3581C24.9915 30.3581 30.0493 25.1813 30.0493 18.7955C30.0493 12.4097 24.9915 7.23297 18.7524 7.23297C12.5133 7.23297 7.45544 12.4097 7.45544 18.7955C7.45544 25.1813 12.5133 30.3581 18.7524 30.3581ZM14.1735 20.5876V22.1576H12.7939V20.5876H9.7505V19.2784L12.9765 14.3235H14.1735L14.1735 19.273H15.0967V20.5876H14.1735ZM11.0848 19.273H12.7942V16.6067L11.0848 19.273ZM18.1839 22.2907C18.9042 22.2907 19.4655 22.0246 19.8679 21.4923C20.3548 20.8466 20.5983 19.7857 20.5983 18.3097C20.5983 16.8302 20.3565 15.7711 19.873 15.1324C19.4672 14.5931 18.9042 14.3235 18.1839 14.3235C17.4636 14.3235 16.9023 14.5896 16.4999 15.1218C16.013 15.7675 15.7695 16.8249 15.7695 18.2938C15.7695 19.791 15.991 20.8315 16.434 21.4152C16.877 21.9988 17.4603 22.2907 18.1839 22.2907ZM17.7265 20.8807C17.86 20.9942 18.013 21.051 18.1855 21.051C18.358 21.051 18.5118 20.9933 18.6471 20.878C18.7823 20.7627 18.8872 20.556 18.9616 20.258C19.0596 19.8748 19.1087 19.2255 19.1087 18.3101C19.1087 17.3947 19.0647 16.7658 18.9768 16.4234C18.8889 16.081 18.7781 15.8522 18.6445 15.7369C18.511 15.6216 18.358 15.5639 18.1855 15.5639C18.013 15.5639 17.8592 15.6216 17.7239 15.7369C17.5887 15.8522 17.4838 16.0589 17.4094 16.3569C17.3114 16.7436 17.2623 17.3947 17.2623 18.3101C17.2623 19.2255 17.3063 19.8544 17.3942 20.1968C17.4821 20.5392 17.5929 20.7671 17.7265 20.8807ZM24.0278 22.2909C24.8867 22.2909 25.558 21.9467 26.0415 21.2584C26.3966 20.7546 26.5741 20.1816 26.5741 19.5394C26.5741 18.7694 26.3543 18.1432 25.9147 17.6607C25.4751 17.1781 24.9392 16.9369 24.3068 16.9369C23.9754 16.9369 23.6508 17.0202 23.3329 17.187L23.5561 15.8618L26.2444 15.8618L26.2444 14.4621H22.4757L21.7453 18.5228L22.9018 18.6985C23.2264 18.3188 23.5933 18.129 24.0025 18.129C24.3305 18.129 24.5968 18.2487 24.8014 18.4882C25.0059 18.7277 25.1082 19.087 25.1082 19.566C25.1082 20.0769 25.0051 20.4592 24.7988 20.7129C24.5925 20.9666 24.3406 21.0934 24.0431 21.0934C23.7827 21.0934 23.5527 20.9949 23.3532 20.798C23.1537 20.6011 23.0337 20.3341 22.9931 19.9971L21.5729 20.1514C21.6574 20.8042 21.9161 21.324 22.3489 21.7108C22.7817 22.0975 23.3414 22.2909 24.0278 22.2909Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3377 5.18292L17.2828 2.67029e-05L19.3927 2.67029e-05L18.3377 5.18292Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1061 6.34928L23.8801 2.44678L25.4221 3.14934L23.1061 6.34928Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57005 8.60323L5.23927 5.701L6.73121 4.17575L9.57005 8.60323Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2351 27.6247L32.5659 30.5269L31.074 32.0522L28.2351 27.6247Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0409 6.36227L11.777 3.12204L13.3312 2.44829L14.0409 6.36227Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.74664 17.6657L0.676948 18.7442L0.676948 16.5872L5.74664 17.6657Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3066 12.8063L3.48934 12.015L4.17655 10.4386L7.3066 12.8063Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07651 27.6377L6.16251 32.0139L4.69684 30.4623L9.07651 27.6377Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83769 22.9519L3.38401 24.7928L2.94769 23.1256L6.83769 22.9519Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.188 31.8173L19.243 37.0002H17.1331L18.188 31.8173Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5549 30.2905L12.7809 34.193L11.2389 33.4904L13.5549 30.2905Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4854 30.2789L25.7493 33.5191L24.1951 34.1929L23.4854 30.2789Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7585 17.8213L36.8282 16.7427V18.8998L31.7585 17.8213Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5889 22.9106L34.4061 23.702L33.7189 25.2783L30.5889 22.9106Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4367 8.60281L30.2755 4.17533L31.7675 5.70058L27.4367 8.60281Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0812 12.919L33.1278 10.4382L33.8673 11.9896L30.0812 12.919Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMenu);
export default __webpack_public_path__ + "static/media/logo-menu.97859d54.svg";
export { ForwardRef as ReactComponent };